
var P;

//https://www.jq22.com/yanshi23645
/*

cocoMessage.config({
    //配置全局参数    
    duration: 10000,
});
//对参数没有顺序要求，
cocoMessage会根据参数的数据类型进行解析
cocoMessage.info(3000, "请先登录！", function() {
    console.log("close");
});
//可以使用dom节点做内容 
var div = document.createElement("div");
div.innerText = "修改成功！";
cocoMessage.success(div); //duration为0时显示关闭按钮
cocoMessage.warning("需要手动关闭", 0);
cocoMessage.error("修改失败！", 3000); //loading可以选择是否展示关闭按钮 
var closeMsg = cocoMessage.loading(true);
setTimeout(function() {
    closeMsg();
}, 4000);
cocoMessage.destroyAll();
*/


"use strict";

 cocoMessage.config({
        duration: 900,
      });





$(document).ready(function(){
  
  

   // console.log(giftcartexist); 
   // console.log(giftvariantsid); 

 //loadShopifyAjaxApiScript();
 // 直接结算
   /* $('#product-add-to-cart-f').on('click', function() {
            console.log("============="); 
 console.log(productvariantsid); 


     
  if( typeof(productvariantsid)!="undefined"){
  if(!productvariantsid){
  Shopify.addItem(productvariantsid , 1 , function() { 
      console.log('success'); 
     }); 
  }
     }
    
    })*/
    
    
   AutomaticallyCheckedDiscount();
 // console.log("eeeeeeeeeeeeeeeeee")
  // console.log($("[data-discount-t='true']").html())
  $("[data-discount-t='true']").click(function(){

    
  var  datadiscount= $(this).attr("data-discount");
    
    copyDiscount(datadiscount);
  });
  

  

});
  
 function loadShopifyAjaxApiScript() 
{ 

var script = document.createElement("script"); 
script.rel = "text/javascript"; 
script.src = "https://cdn.shopify.com/s/assets/themes_support/api.jquery-0ea851da22ae87c0290f4eeb24bc8b513ca182f3eb721d147c009ae0f5ce14f9.js"; 
document.getElementsByTagName("head")[0].appendChild(script); 

} 
  
function copyDiscount(Discountvalue)
    {
       
        var oInput = document.createElement('input');
        oInput.value = Discountvalue;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.className = 'oInput';
        oInput.style.display='none';
       
        cocoMessage.success("Promo code copied");
      
    }


function AutomaticallyCheckedDiscount()
{
 // console.log("eeeeeeeeeeeeeeeeee")
   
 var cade= $("[data-discount-t='true']").attr("data-discount");

    //console.log(cade)
    
    //console.log(typeof(cade))
    //  console.log(typeof(cade)!="undefined")
    
  if(cade!="" && typeof(cade)!="undefined"){
    
     // console.log("eeeeeeeeeeeeeeeeee333")
  var url="https://de.realrelaxmassage.com/discount/"+cade+"?redirect="+window.location.pathname;
  
   $.ajax({url:url,success:function(result){
       // alert('aaaa');
    }});
  }
  
}



